export const subfoldersMapping: any = {
  "tenant-pf": "Documentos del Inquilino",
  "tenant-pm": "Documentos del Inquilino",
  "tenant-pf-cja": "Documentos del Inquilino",
  "tenant-pm-cja": "Documentos del Inquilino",
  "guarantor-pf": "Documentos del Fiador",
  "guarantor-pf-cja": "Documentos del Fiador",
  "guarantor-pm": "Documentos del Fiador",
  "guarantor-pm-cja": "Documentos del Fiador",
  "guarantor-investigation-pf": "Documentos del Fiador",
  "guarantor-investigation-pm": "Documentos del Fiador",
  collateral: "Inmueble en Garantía",
  "lease-contract": "Contrato de Arrendamiento",
  "lease-contract-pf": "Contrato de Arrendamiento",
  "lease-contract-pm": "Contrato de Arrendamiento",
  "landlord-pf": "Documentos del Propietario",
  "landlord-pm": "Documentos del Propietario",
  "owner-representative": "Representante del Propietario",
  "owner-representative-pm": "Representante del Propietario",
};

export const subfoldersOrder: string[] = Object.keys(subfoldersMapping).map(
  (template: any) => template,
);
